import { useState } from 'react';

import { useLazyGetDetectorCatalogQuery } from './detectorCatalogApi';
import DetectorQueriesView from './DetectorQueriesView';
import { loadableOf } from './loadable';

const PREFER_CACHED_CATALOG = true;

function DetectorQueries(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [loadCatalog, catalog] = useLazyGetDetectorCatalogQuery();

  return (
    <DetectorQueriesView
      open={open}
      catalog={loadableOf(catalog)}
      onOpen={() => {
        setOpen(true);
        void loadCatalog(undefined, PREFER_CACHED_CATALOG);
      }}
      onClose={() => setOpen(false)}
    />
  );
}

export default DetectorQueries;
